import lscache from 'lscache';
import OAuthButton from 'modules/authentication/components/AuthButtons/OAuthButton';
import { signIn } from 'modules/authentication/helpers/auth';
import React, { useState } from 'react';

type FacebookLoginProps = {
  isLogin?: boolean;
  callbackUrl?: string;
  onLoginResult: (
    state: any,
  ) => ({
    error,
    success,
    redirectUrl,
  }: {
    error?: any;
    success: boolean;
    redirectUrl?: string;
  }) => void;
  afterLogin?: () => boolean;
  isLastUsed?: boolean;
};

const INITIAL_STATE = {
  loading: false,
  error: null,
};

function FacebookLogin({
  isLogin,
  afterLogin,
  callbackUrl,
  onLoginResult,
  isLastUsed,
}: FacebookLoginProps) {
  const [state, setState] = useState(INITIAL_STATE);

  const onLoginClick = async () => {
    setState({ error: null, loading: true });
    try {
      await signIn('facebook', callbackUrl, onLoginResult(setState));
      lscache.set('lastUsedProvider', 'facebook');
      const hideLoading = afterLogin?.();
      if (hideLoading) {
        setState({ error: null, loading: false });
      }
    } catch (exception) {
      setState({ error: exception, loading: false });
    }
  };

  return (
    <OAuthButton
      onClick={onLoginClick}
      provider="facebook"
      isLogin={isLogin}
      isLoading={state.loading}
      hasError={!!state.error}
      isLastUsed={isLastUsed}
    />
  );
}

export default FacebookLogin;
